// third party provider natively supported by Firebase (e.g. Intuit SSO is not supported)
export enum SsoProvider {
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  OIDC = 'OIDC',
  SAML = 'SAML',
}
